export const RESOLVE_ATTACHMENTS_SUCCEEDED = 'RESOLVE_ATTACHMENTS_SUCCEEDED';
export const RESOLVE_ATTACHMENTS_FAILED = 'RESOLVE_ATTACHMENTS_FAILED';
export const resolveAttachmentsSucceeded = ({
  fileIds,
  resolvedAttachments
}) => ({
  type: RESOLVE_ATTACHMENTS_SUCCEEDED,
  payload: {
    fileIds,
    resolvedAttachments
  }
});
export const resolveAttachmentsFailed = ({
  fileIds
}) => ({
  type: RESOLVE_ATTACHMENTS_FAILED,
  payload: {
    fileIds
  }
});